import { Box, Grid, Skeleton, Stack } from "@mui/material/node";
import TableRow from "@mui/material/TableRow";

import styled from "@emotion/styled";

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "#white",
  },
  justifyContent: "flex-start",
  alignItems: "flex-start",
  // hide last border
  "&:last-child td, &:last-child th": {
    border: "0px solid red",
  },
  borderBottom: "1px solid #ddd",
}));

const LoadingRows = ({ num }) => {
  const skeletonLines = Array.from({ length: num }, (_, index) => (
    <Grid item key={index} xs={12}>
      <Skeleton
        animation="wave"
        height={130}
        width="100%"
        sx={{ marginY: "-25px", padding: 0 }}
      />
    </Grid>
  ));
  return (
    <>
      <Grid container spacing={0}>
        {skeletonLines}
      </Grid>
    </>
  );
};

export default LoadingRows;
